import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { translate } from 'react-i18next'

import { selectContact, contactIsInCall } from '../../actions'
import FormAddLog from './FormAddLog'
import ContactForm from './ContactForm'
import ContactLogs from '../Contacts/ContactLogs'

import { Modal, Button, Tabs, Radio } from 'antd'
const TabPane = Tabs.TabPane
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

class ContactModal extends Component {
  state = { contactReached: null }

  handleContactReachedChange = e => {
    const contactReached = e.target.value

    this.setState({ contactReached })
  }

  closeModal = () => {
    const { selectContact, nav } = this.props

    selectContact(null)
    this.setState({ contactReached: null })

    // call has ended - save info into DB
    if (nav.contact && nav.contact.action === 'call') {
      const { match: { params }, contactIsInCall } = this.props
      contactIsInCall(false, nav.contact.id, params.projectId)
    }
  }

  render () {
    // console.log('   RENDER: ContactModal')

    const { t, nav, contacts } = this.props
    const { contactReached } = this.state

    // if (!contacts || !nav.contact) return <div />

    const currentContact = contacts && nav.contact && contacts[nav.contact.id]

    return (
      <Modal
        visible={nav.contact && true}
        title={nav.contact && currentContact && t(`contact.${nav.contact.action}`)}
        onCancel={() => this.closeModal()}
        footer={null}
        width={700}
      >
        {nav.contact &&
          <div>
            {nav.contact.action === 'call' || nav.contact.action === 'edit'
              ? <div>

                <Tabs type='card'>
                  <TabPane tab='Info' key='1'>
                    <ContactForm contact={currentContact} />
                  </TabPane>
                  <TabPane tab='Logs' key='2'>
                    <ContactLogs contactId={currentContact.id} />
                  </TabPane>
                </Tabs>

                {nav.contact.action === 'call' &&
                <div style={{ marginTop: 30 }}>
                  <div style={{ textAlign: 'center' }}>

                    <div style={{ margin: '20px 0' }}>
                      {['phoneCentral', 'phoneDirect'].map(
                            phoneType =>
                              currentContact[phoneType] &&
                              <Button
                                key={phoneType}
                                icon='phone'
                                href={'tel:' + currentContact[phoneType]}
                                style={{ margin: '0 10px' }}
                              >
                                {t(`contact.fields.${phoneType}`)}
                              </Button>
                          )}
                    </div>

                    <hr style={{ margin: '10px -24px' }} />

                    <h3 style={{ marginTop: 25 }}>Contact reached?</h3>
                    <RadioGroup onChange={this.handleContactReachedChange}>
                      <RadioButton checked={contactReached === true} value>YES</RadioButton>
                      <RadioButton checked={contactReached === false} value={false}>NO</RadioButton>
                    </RadioGroup>
                  </div>

                  {contactReached !== null &&
                  <FormAddLog key={Date.now()} contact={currentContact} contactReached={contactReached} />}

                </div>}

              </div>
              : <ContactForm contact={null} />}
          </div>}

      </Modal>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  nav: state.nav,
  contacts: state.contacts,
  user: state.user
})

const mapDispatchToProps = {
  selectContact,
  contactIsInCall
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(translate('translations')(ContactModal)))



// WEBPACK FOOTER //
// ./src/components/ContactModal/ContactModal.js